import { Component, inject } from '@angular/core';
import { TruckService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  TruckCreateDto,
  TruckDto,
  TruckExcelDownloadDto,
  TruckUpdateDto,
} from '../proxy/general/dtos/truck';
import { TRUCK_CONFIG, TRUCK_FIELDS } from './truck.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-truck',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, TruckService, ConfirmationService],
  templateUrl: './truck.html',
  styleUrl: './truck.scss',
})
export class Truck extends BaseHierarchicalCrudComponent<
  TruckDto,
  TruckCreateDto,
  TruckUpdateDto,
  TruckExcelDownloadDto
> {
  service = inject(TruckService);
  config = TRUCK_CONFIG;
  fields = TRUCK_FIELDS;

  protected prepareUpdateDto(data: any, selected: TruckDto): TruckUpdateDto {
    return {
      vehicleId: data.vehicleId,
      engagedWithId: data.engagedWithId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Truck';
  }
}
